import { useMemo } from 'react';

import { useMatchesViewport } from '../../../hooks/media';
import type { ProductListVariation } from '../types/types';
import { getSwatchesFromVariations } from '../utils/utils';

interface UseSwatchDataReturn {
  swatches: ReturnType<typeof getSwatchesFromVariations>['swatches'];
  allSwatchesCount: number;
  visibleSwatchesCount: number;
  isMobile: boolean;
}

export const useSwatchData = (variations: ProductListVariation[]): UseSwatchDataReturn => {
  const {
    matches: { matchesTablet },
  } = useMatchesViewport();

  const isMobile = !matchesTablet;

  const { swatches, allSwatchesCount, visibleSwatchesCount } = useMemo(
    () => getSwatchesFromVariations(variations, isMobile),
    [variations, isMobile]
  );

  return { swatches, allSwatchesCount, visibleSwatchesCount, isMobile };
};
